'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('./tslib.es6-f8b34207.js');
var memoryStorage = require('./memoryStorage.js');
var _storageService = require('./_storageService-fcdc54f2.js');

var LocalStore = /** @class */ (function (_super) {
    tslib_es6.__extends(LocalStore, _super);
    function LocalStore(storePrefix) {
        if (storePrefix === void 0) { storePrefix = null; }
        var _this = _super.call(this, storePrefix) || this;
        try {
            _this.storage = localStorage;
        }
        catch (e) {
            console.warn('Cannot get access to the localStorage, reason:', e);
            _this.storage = memoryStorage.MemoryStorage();
        }
        return _this;
    }
    return LocalStore;
}(_storageService.StorageService));
var localStore = new LocalStore();

exports.LocalStore = LocalStore;
exports.localStore = localStore;
